import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type SectionHeadLevel = 1 | 2;

/**
 * The kicker + display-heading editorial pattern the home page composes
 * inline (`.home-kicker` + a `groove-type-display` heading). Lifted out so
 * the labs pages (and, later, home itself) can reuse it verbatim.
 *
 * `kicker` is the FULL kicker phrase, rendered as one `.groove-arc-swash`
 * span — Groove's mask for that class stretches to the span's width, so the
 * gold arc rides under the whole phrase rather than a single word (round two
 * #4: decorating only one word read as an arbitrary pick out of the phrase).
 * `headingId` is required — consuming pages use it for `aria-labelledby` and
 * in-page jump-nav anchors. `level` defaults to `2` (the pattern's normal use
 * as a section heading); pass `1` for a page-level heading (the hub's own
 * `<h1>`).
 */
@Component({
  selector: 'app-section-head',
  templateUrl: './section-head.component.html',
  styleUrl: './section-head.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeadComponent {
  readonly kicker = input.required<string>();
  readonly heading = input.required<string>();
  readonly headingId = input.required<string>();
  readonly level = input<SectionHeadLevel>(2);
}
